import React, { useState, useEffect } from "react";
import "./axiosResponseInterceptor";
import "./App.css";
import "./ThemeContext.css";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// AMCCustomer
// import AMCCustomerForm from "../RunningAccountsProjects/AMCCustomer/AMCCustomerForm";
import AMCCustomerForm from "./RunningAccountsProject/AmcCustomer/AMCCustomerForm";
import AMCCustomerTable from "./RunningAccountsProject/AmcCustomer/AMCCustomerTable";
import AMCCustomerEditForm from "./RunningAccountsProject/AmcCustomer/AMCCustomerEditForm";

import AMCProjectForm from "./RunningAccountsProject/AmcProject/AMCProjectForm";
import AMCProjectTable from "./RunningAccountsProject/AmcProject/AMCProjectTable";
import AMCProjectEditForm from "./RunningAccountsProject/AmcProject/AMCProjectEditForm";

import BOQForm from "./RunningAccountsProject/BOQ/BOQForm";
import BOQTable from "./RunningAccountsProject/BOQ/BOQTable";
import BOQEditForm from "./RunningAccountsProject/BOQ/BOQEditForm";

import BOQAddQtyForWeek from "./RunningAccountsProject/BOQ/BOQAddQtyForWeek";
import BOQAddQtyForMonths from "./RunningAccountsProject/BOQ/BOQAddQtyForMonths";
import BOQReports from "./RunningAccountsProject/BOQ/BOQReports";
import BOQAddQtyDetails from "./RunningAccountsProject/BOQ/BOQAddQtyDetails";

import PMListView from "./Component/DashboardListView/PMListView.js";
import Breakdownlistview from "./Component/DashboardListView/Breakdownlistview.js";
import Amclistview from "./Component/DashboardListView/Amclistview.js";
import Hrmlistview from "./Component/DashboardListView/Hrmlistview.js";
import StatutoryApprovalsListView from "./Component/DashboardListView/StatutoryApprovalsListView.js";
import PRListView from "./Component/DashboardListView/PRListView.js";
import POListView from "./Component/DashboardListView/POListView.js";
import WorkPermitListView from "./Component/DashboardListView/WorkPermitListView.js";
import AuditListView from "./Component/DashboardListView/AuditListView.js";

// Audit
import AuditForm from "./Audit/AuditForm";
import AuditEditForm from "./Audit/AuditEditForm";
import AuditTable from "./Audit/AuditTable";
import AuditView from "./Audit/AuditView";

// Reports
import ReportPage from "./AllReports/ReportPage";
import ScheduleGenerator from "./AllReports/ScheduleGenerator";

// ReportsView
import AmcReportView from "./AllReportsView/AmcReportView";
import ProcurementReportView from "./AllReportsView/ProcurementReportView";
import PreventiveReportView from "./AllReportsView/PreventiveReportView";

// ScheduleView
import AmcSchedulesView from "./AllScheduleView/AmcSchedulesView";
import BreakdownView from "./AllScheduleView/BreakdownView";
import PreventiveSchedulesView from "./AllScheduleView/PreventiveSchedulesView";

// AllSchedules
import AllPreventiveSchedules from "./AllSchedules/AllPreventiveSchedules";
import BreakDownSchedules from "./AllSchedules/BreakDownSchedules";
import AllAmcSchedules from "./AllSchedules/AllAmcSchedules";
import ElectricalDepartment from "./AllSchedules/ElectricalDepartment";
// ArchivedsTables
import ArchivedUser from "./ArchivedsTables/ArchivedUser";
import ArchivedCustomer from "./ArchivedsTables/ArchivedCustomer";
import ArchivedManPowerRequire from "./ArchivedsTables/ArchivedManPowerRequire";
import ArchivedProject from "./ArchivedsTables/ArchivedProject";
import ArchivedContractorCompany from "./ArchivedsTables/ArchivedContractorCompany";
import ArchivedDepartment from "./ArchivedsTables/ArchivedDepartment";
import ArchivedSubDepartment from "./ArchivedsTables/ArchivedSubDepartment";
import ArchivedEquipment from "./ArchivedsTables/ArchivedEquipment";
import ArchivedEquipmentType from "./ArchivedsTables/ArchivedEquipmentType";
import AdminUserAccessTable from "./AdminuserAccess/AdminUserAccessTable";
import ArchivedEquipmentSubType from "./ArchivedsTables/ArchivedEquipmentSubType";
import ArchivedEquipmentSubTypevariant from "./ArchivedsTables/ArchivedEquipmentSubTypevariant";
import ArchivedAllSchedules from "./ArchivedsTables/ArchivedAllSchedules";
import ArchivedAllAmcSchedules from "./ArchivedsTables/ArchivedAllAmcSchedules";
import ArchivedAllAmcs from "./ArchivedsTables/ArchivedAllAmcs";
import ArchivedBreakdown from "./ArchivedsTables/ArchivedBreakdown";
import ArchivedVendor from "./ArchivedsTables/ArchivedVendor";
import ArchivedPrRequest from "./ArchivedsTables/ArchivedPrRequest";
import ArchivedPrRequestList from "./ArchivedsTables/ArchivedPrRequestList";
import ArchivedApprovedPR from "./ArchivedsTables/ArchivedApprovedPR";
import ArchivedStatutory from "./ArchivedsTables/ArchivedStatutory";
import ArchivedInventory from "./ArchivedsTables/ArchivedInventory";
import ArchivedPoList from "./ArchivedsTables/ArchivedPoList";
import ArchivedInward from "./ArchivedsTables/ArchivedInward";
import ArchivedTechnicalList from "./ArchivedsTables/ArchivedTechnicalList";
import ArchivedRejectedStock from "./ArchivedsTables/ArchivedRejectedStock";
import ArchivedAmcConsumption from "./ArchivedsTables/ArchivedAmcConsumption";
import ArchivedOutwardlist from "./StoreManagement/ArchivedOutwadrlist";
import ArchivedDocumentCategory from "./ArchivedsTables/ArchivedDocumentCategory";
import ArchivedSafetyInduction from "./ArchivedsTables/ArchivedSafetInduction";
import ArchivedActualmanPower from "./ArchivedsTables/ArchivedActualmanPower";

// import ArchivedHrList from "./ArchivedsTables/ArchivedHrList";
import ArchivedhrList from "./ArchivedsTables/ArchivedhrList";
import ArchivedMatcode from "./ArchivedsTables/ArchivedMatcode";
import ArchivedLevel1 from "./ArchivedsTables/ArchivedLevel1";
import ArchivedLevel2 from "./ArchivedsTables/ArchivedLevel2";
import ArchivedLevel3 from "./ArchivedsTables/ArchivedLevel3";
import ArchivedFrequency from "./ArchivedsTables/ArchivedFrequency";
import ArchivedDesignations from "./ArchivedsTables/ArchivedDesignatons";

// Component
import SignUp from "./Component/SignUp";
import Login from "./Component/Login";
import Sidebar from "./Component/Sidebar";
import Dashboard from "./Component/Dashboard";
import Header from "./Component/Header";
import NewDashboard from "./Component/NewDashboard";
import NewDashboardPage from "./Component/NewDashboardPage";
import PageNotFound from "./Component/PageNotFound";

import LocationList from "./MiIndex/LocationList.js";

// EditsForms
import EditSafetyInduction from "./EditsForms/EditSafetyInduction";
import EditHsePolicy from "./EditsForms/EditHsePolicy";
import EditSafetyMeeting from "./EditsForms/EditSafetyMeeting";
import EditSafetyObservation from "./EditsForms/EditSafetyObservation";
import EditEmailConfig from "./EditsForms/EditEmailConfig";
import EditLibraryDocument from "./EditsForms/EditLibraryDocument";
import EditLibraryCategory from "./EditsForms/EditLibraryCategory";
import EditSidePettyCash from "./EditsForms/EditSidePettyCash";
import EditCustomer from "./EditsForms/EditCustomer";
import EditPOConfiguration from "./EditsForms/EditPOConfiguration";
import EditOutward from "./EditsForms/EditOutward";
import EditInward from "./EditsForms/EditInward";
import EditPRRequest from "./EditsForms/EditPRRequest";
import EditProject from "./EditsForms/EditProject";
import EditContractor from "./EditsForms/EditContractor";
import EditUserForm from "./EditsForms/EditUserForm";
import EditAmcForm from "./EditsForms/EditAmcForm";
import EditManpower from "./EditsForms/EditManpower";
import EditActualManpower from "./EditsForms/EditActualManpower";
import EditVendor from "./EditsForms/EditVendor";
import EditMatCode from "./EditsForms/EditMatCode";
import EditDesignation from "./EditsForms/EditDesignation";
import EditFrequency from "./EditsForms/EditFrequency";
import EditStatutoryCompliance from "./EditsForms/EditStatutoryCompliance";
import EditBreakdown from "./EditsForms/EditBreakdown";
import EditEquipmentType from "./EditsForms/EditEquipmentType";
import EditNewEquipment from "./EditsForms/EditNewEquipment";
import EditEquipmentSubType from "./EditsForms/EditEquipmentSubType";
import EditEquipmentSubTypeVariant from "./EditsForms/EditEquipmentSubTypeVariant";
import EditDepartment from "./EditsForms/EditDepartment";
import EditVoyage from "./EditsForms/EditVoyage";
import EditSubDepartment from "./EditsForms/EditSubDepartment";
import EditHRModules from "./EditsForms/EditHRModules";
import EditDailyProgress from "./EditsForms/EditDailyProgress";
import EditEmailTemplate from "./EditsForms/EditEmailTemplate";
import EditHrCompilance from "./EditsForms/EditHrCompilance";
import EditReturnable from "./EditsForms/EditReturnable";

// forms
import DailyProgressForm from "./forms/DailyProgressForm";
import EmailConfigForm from "./forms/EmailConfigForm";
import SafetyInductionForm from "./forms/SafetyInductionForm";
import HsePolicyForm from "./forms/HsePolicyForm";
import SafetyMeetingForm from "./forms/SafetyMeetingForm";
import SafetyObservationForm from "./forms/SafetyObservationForm";
import LibraryCategoryForm from "./forms/LibraryCategoryForm";
import LibraryDocumentsForm from "./forms/LibraryDocumentsForm";
import SatutoryForm from "./forms/SatutoryForm";
import VoyageForm from "./forms/VoyageForm";
import MonthlyInventoryReport from "./forms/MonthlyInventoryReport";
import UserForm from "./forms/UserForm";
import VendorForm from "./forms/VendorForm";
import SidePettyCashForm from "./forms/SidePettyCashForm";
import EquipmentForm from "./forms/EquipmentForm";
import AmcSchedulesForm from "./forms/AmcSchedulesForm";
import NewEquipmentForm from "./forms/NewEquipmentForm";
import ProjectForm from "./forms/ProjectForm";
import PRRequestForm from "./forms/PRRequestForm";
import CustomerForm from "./forms/CustomerForm";
import BreakDownForm from "./forms/BreakDownForm";
import ManpowerRequirmentForm from "./forms/ManpowerRequirmentForm";
import ActualManpowerForm from "./forms/ActualManpowerForm";
import DesignationForm from "./forms/DesignationForm";
import ContractorCompanyForm from "./forms/ContractorCompanyForm";
import EquipmentSubTypeForm from "./forms/EuipmentSubTypeForm";
import FrequencyConfig from "./forms/FrequencyConfig";
import EquipmentTypeForm from "./forms/EquipmentTypeForm";
import HRForm from "./forms/HRForm";
import EquipmentTypevariantForm from "./forms/EquipmentTypevariantForm";
import DepartmentForm from "./forms/DepartmentForm";
import SubDepartmentForm from "./forms/SubDepartmentForm";
import StatutoryComplianceForm from "./forms/StatutoryComplianceForm";
import HrCompilanceForm from "./forms/HrCompilanceForm";
import ReturnableForm from "./forms/ReturnableForm";
import ManualWorkPermitForm from "./forms/ManualWorkPermitForm";

// MateCode
import LevelConfig from "./Matcode/LevelConfig";
import Level1Form from "./Matcode/Level1Form";
import UpdateMatCodeLevel1 from "./Matcode/UpdateMatCodeLevel1";
import UpdateMatCodeLevel2 from "./Matcode/UpdateMatCodeLevel2";
import UpdateMatCodeLevel3 from "./Matcode/UpdateMatCodeLevel3";
import MatCodeConfigForm from "./Matcode/MatCodeConfigForm";
import Level2Form from "./Matcode/Level2Form";
import Level3Form from "./Matcode/Level3Form";
import MatCode from "./Matcode/MatCode";
import UpdateMatCode from "./Matcode/UpdateMatCode";

import TrainingSessionsListPage from "./hr/training/TrainingSessionsListPage";
import TrainingSessionFormPage from "./hr/training/TrainingSessionFormPage";
import TrainingSessionViewPage from "./hr/training/TrainingSessionViewPage";
import TrainingMastersListPage from "./hr/training/TrainingMastersListPage";
import TrainingMasterFormPage from "./hr/training/TrainingMasterFormPage";
import TrainingMasterViewPage from "./hr/training/TrainingMasterViewPage";
import TrainingDashboardPage from "./hr/training/TrainingDashboardPage";
import TrainingDueOverduePage from "./hr/training/TrainingDueOverduePage";
import TrainingEmployeeHistoryPage from "./hr/training/TrainingEmployeeHistoryPage";
import TrainingStandardsListPage from "./hr/training/TrainingStandardsListPage";
import TrainingStandardFormPage from "./hr/training/TrainingStandardFormPage";
import TrainingStandardViewPage from "./hr/training/TrainingStandardViewPage";
import TrainingParticipantsListPage from "./hr/training/TrainingParticipantsListPage";
import TrainingParticipantFormPage from "./hr/training/TrainingParticipantFormPage";
import MedicalReportsListPage from "./hr/medical/MedicalReportsListPage";
import MedicalReportFormPage from "./hr/medical/MedicalReportFormPage";
import MedicalReportViewPage from "./hr/medical/MedicalReportViewPage";
import MedicalCompliancePage from "./hr/medical/MedicalCompliancePage";
import MedicalDashboardPage from "./hr/medical/MedicalDashboardPage";
import MedicalDueOverduePage from "./hr/medical/MedicalDueOverduePage";
import ReminderSettingsPage from "./hr/ReminderSettingsPage";
import EmailLogPage from "./hr/EmailLogPage";

// StoreManagement
import AmcConsumption from "./StoreManagement/AmcConsumption";
import AmcConsumptionHistory from "./StoreManagement/AmcConsumptionHistory";
import POConfigurationForm from "./StoreManagement/POConfigurationForm";
import POConfigurationlist from "./StoreManagement/POConfigurationlist";
import PoLisTtab from "./StoreManagement/PoListTab";
import InwardForm from "./StoreManagement/InwardForm";
import OutwardForm from "./StoreManagement/OutwardForm";
import InwardList from "./StoreManagement/InwardList";
import OutwardList from "./StoreManagement/OutwardList";
import POView from "./StoreManagement/POView";
import InwardView from "./StoreManagement/InwardView";
import OutwardView from "./StoreManagement/OutwardView";
import GeneratePO from "./StoreManagement/GeneratePO";
import Inventory from "./StoreManagement/Inventory";
import RejectedStock from "./StoreManagement/RejectedStock";
import InventoryView from "./StoreManagement/InventoryView";
import RejectedStockView from "./StoreManagement/RejectedStockView";
import InventoryHistory from "./StoreManagement/InventoryHistory";
import RejectedHistory from "./StoreManagement/RejectedHistory";
import TechnicalRequestList from "./StoreManagement/TechnicalRequestList";
import TechnicalRequestListView from "./StoreManagement/TechnicalRequestListView";
import ApprovedTechnical from "./StoreManagement/ApprovedTechnical";
import ApprovedTechnicalView from "./StoreManagement/ApprovedTechnicalView";
// tables
import EmailConfig from "./tables/EmailConfig";
import EmailTemplateForm from "./forms/EmailTemplateForm";
import EmailTemplate from "./tables/EmailTemplate";
import DailyProgress from "./tables/DailyProgress";
import HrTable from "./tables/HrTable";
import SafetyInduction from "./tables/SafetyInduction";
import HsePoliciesList from "./tables/HsePoliciesList";
import SafetyMeetingsList from "./tables/SafetyMeetingsList";
import SafetyObservationList from "./tables/SafetyObservationList";
import User from "./tables/User";
import PRRequest from "./tables/PRRequest";
import Vendor from "./tables/Vendor";
import AmcSchedules from "./tables/AmcSchedules";
import NewEquipment from "./tables/NewEquipment";
import SidePettyCash from "./tables/SidePettyCash";
import ContractorCompany from "./tables/ContractorCompany";
import EquipmentSubType from "./tables/EquipmentSubType";
import EquipmentType from "./tables/EquipmentType";
import EquipmentTypevariant from "./tables/EquipmentTypevariant";
import ReminderDetails from "./tables/ReminderDetails";
import Project from "./tables/Project";
import Designation from "./tables/Designation";
import Customer from "./tables/Customer";
import Department from "./tables/Department";
import ManpowerRequirment from "./tables/ManpowerRequirment";
import ActualManpower from "./tables/ActualManpower";
import Frequency from "./tables/Frequency";
import UserType from "./tables/UserType";
import PRRequestList from "./tables/PRRequestList";
import PRRequestListTab from "./tables/PRRequestListTab";
import ApprovedPRList from "./tables/ApprovedPRList";
import SubDepartment from "./tables/SubDepartment";
import ReportManpower from "./tables/ReportManpower";
import StatutoryCompliance from "./tables/StatutoryCompliance";
import DocumentCategory from "./tables/DocumentCategory";
import DocumentLibrary from "./tables/DocumentLibrary";
import UserAccessTable from "./UserAcess/UserAccessTable";
import HrCompilances from "./tables/HrCompilances";
import Returnable from "./tables/Returnable";
import VoyageList from "./tables/VoyageList";
import MonthlyInventoryReportList from "./tables/MonthlyInventoryReportList";
import ManualWorkPermitList from "./tables/ManualWorkPermitList";

import CustomerList from "./BarrelManagement/Customer/CustomerList.js";
import ViewCustomer from "./BarrelManagement/Customer/ViewCustomer.js";
import ProductList from "./BarrelManagement/Product/ProductList.js";
import BarrelInwardList from "./BarrelManagement/Inward/BarrelInwardList.js";
import StockLedgerList from "./BarrelManagement/Inward/StockLedgerList.js";

import PurchaseIndentsList from "./BarrelManagement/PurchaseIndents/PurchaseIndentsList.js";

import CalibrationReports from "./GasDetectorCalibrationReport/CalibrationReports";
import CalibrationReportView from "./GasDetectorCalibrationReport/CalibrationReportView";

// Cold Work Permint
import AddNewPermitField from "./ColdWorkPermit/AddNewPermitField";
import TemplategetForm from "./ColdWorkPermit/TemplategetForm";
import TemplateApiEndPoint from "./ColdWorkPermit/TemplateApiEndPoint";

import PermitRequestForm from "./ColdWorkPermit/PermitRequestForm";
import PermitRequestFormEdit from "./ColdWorkPermit/PermitRequestFormEdit";
import PermitRequestForRequesterTab from "./ColdWorkPermit/PermitRequestForRequesterTab";
import PermitRequestForIssuerTab from "./ColdWorkPermit/PermitRequestForIssuerTab";
import PermitRequestForSafetyTab from "./ColdWorkPermit/PermitRequestForSafetyTab";
import PermitRequestofExcavation from "./RoadClosureWorkPermit/PermitRequestofExcavation";
import IssuerAllDepartmentForms from "./RoadClosureWorkPermit/IssuerAllDepartmentForms";
import PermitRequestEditTab from "./ColdWorkPermit/PermitRequestEditTab";
import PermitExtensionRequestView from "./ColdWorkPermit/PermitExtensionRequestView";
import PermitExtensionRequestRequesterView from "./ColdWorkPermit/PermitExtensionRequestRequesterView";
import PermitPdfFormate from "./ColdWorkPermit/PermitPdfFormate";
import ColdWorkPermitTemplate from "./ColdWorkPermit/ColdWorkPermitTemplate";
import ConfinedSpaceTemplate from "./ConfiedSpaceWorkPermit/ConfinedSpaceTemplate";
import PermitExtensionRequestEdit from "./ColdWorkPermit/PermitExtensionRequestEdit";
import PermitRequestRejectView from "./ColdWorkPermit/PermitRequestRejectView";
// import PermitRequestForOMHead from "./ColdWorkPermit/PermitRequestForOMHead";
import PermitRequestForOMHeadTab from "./ColdWorkPermit/PermitRequestForOMHeadTab";

import Form1 from "./ColdWorkPermit/Form1";
import Form2 from "./ColdWorkPermit/Form2";
import Form3 from "./ColdWorkPermit/Form3";
import Form4 from "./ColdWorkPermit/Form4";
import Form5 from "./ColdWorkPermit/Form5";
import PermitViewPage from "./ColdWorkPermit/PermitViewPage";
import ExcavationPermitViewPage from "./RoadClosureWorkPermit/ExcavationPermitViewPage";
import ExcavationViewInspection from "./RoadClosureWorkPermit/ExcavationViewInspection";
import ExcavationDepartmentApprovalSetup from "./RoadClosureWorkPermit/ExcavationDepartmentApprovalSetup";
import AddExcavationDepartmentApprovalSetup from "./RoadClosureWorkPermit/AddExcavationDepartmentApprovalSetup";
import EditExcavationDepartmentApprovalSetup from "./RoadClosureWorkPermit/EditExcavationDepartmentApprovalSetup";
import ExcavationDepartmentReviewerConfiguration from "./RoadClosureWorkPermit/ExcavationDepartmentReviewerConfiguration";
import AddExcavationReviewerConfiguration from "./RoadClosureWorkPermit/AddExcavationReviewerConfiguration";
import EditExcavationReviewerConfiguration from "./RoadClosureWorkPermit/EditExcavationReviewerConfiguration";

import WorkPermitConfig from "./ColdWorkPermit/WorkPermitConfig";
import CloseRequestTabIssuer from "./ColdWorkPermit/CloseRequestTabIssuer";
import CloseRequestTabRequester from "./ColdWorkPermit/CloseRequestTabRequester";
import CloseRequestTabInspection from "./ColdWorkPermit/CloseRequestTabInspection";
import ColdWorkPermitInspectionView from "./ColdWorkPermit/ColdWorkPermitInspectionView";
import IssuerViewDetails from "./ColdWorkPermit/IssuerViewDetails";
import EditExtensionRequestReason from "./ColdWorkPermit/EditExtensionRequestReason";

// Hot Work Permint
import HotWorkPermitTemplate from "./HotWorkPermit/HotWorkPermitTemplate";

// Views
import HRView from "./Views/HRView";
import DailyProgressEmailHistory from "./Views/DailyProgressEmailHistory";
import UserView from "./Views/UserView";
import ContractorView from "./Views/ContractorView";
import CustomerView from "./Views/CustomerView";
import FrequencyConfigView from "./Views/FrequencyConfigView";
import ProjectView from "./Views/ProjectView";
import EquipmentView from "./Views/EquipmentView";
import StatutoryCompliancesView from "./Views/StatutoryCompliancesView";
import ManpowerHistory from "./Views/ManpowerHistory";
import PrVendorDetails from "./Views/PrVendorDetails";
import History from "./Views/History";
import Breakdownreportview from "./Views/Breakdownreportview";
import PRRequestView from "./Views/PRRequestView";
import PRRequestDetail from "./Views/PRRequestDetail";
import VendorView from "./Views/VendorView";
import ApprovedPrView from "./Views/ApprovedPrView";
import AmcView from "./Views/AmcView";
import HsePolicyView from "./Views/HsePolicyView";
import SafetyMeetingsView from "./Views/SafetyMeetingsView";
import SafetyObservationView from "./Views/SafetyObservationView";
import VoyageView from "./Views/VoyageView";
import MonthlyInventoryView from "./Views/MonthlyInventoryView";
import EquipmentCountView from "./Views/EquipmentCountView";

import NotificationComponent from "./Component/NotificationComponent";

import ReportLog from "./MonthlyReportLog/ReportLog";
import AllNotification from "./Popups/AllNotification";
import IsolationTemplate from "./ElectricalIsolation/IsolationTemplate";
import IsolationPermitList from "./ElectricalIsolation/IsolationPermitList";
import RequestIsolation from "./ElectricalIsolation/RequestIsolation";
import RequestEnergisation from "./ElectricalIsolation/RequestEnergisation";
import CetificateIsolation from "./ElectricalIsolation/CetificateIsolation";
import CetificateEnergisation from "./ElectricalIsolation/CetificateEnergisation";

// Gas detector
import GasDetectorForm from "./RunningAccountsProject/GasDetector/GasDetectorForm";
import GasDetectorTypes from "./RunningAccountsProject/GasDetector/GasDetctorType";
import AddGasDetectorType from "./RunningAccountsProject/GasDetector/AddGasDetctorType";
import EditDetectorType from "./RunningAccountsProject/GasDetector/EditDetectorType";
import AllGasDetector from "./RunningAccountsProject/GasDetector/AllGasDetector";
import EditGasDetector from "./RunningAccountsProject/GasDetector/EditGasDetector";
import GasDetectorCallibaration from "./RunningAccountsProject/GasDetector/GasDetectorCallibaration";
import AllGasCylinders from "./RunningAccountsProject/GasDetector/CylinderInventory/AllGasCylinders";
import AddCylinder from "./RunningAccountsProject/GasDetector/CylinderInventory/AddCylinder";
import EditGasCylinder from "./RunningAccountsProject/GasDetector/CylinderInventory/EditGasCylinder";
import CylinderLogs from "./RunningAccountsProject/GasDetector/CylinderInventory/CylinderLogs";
import CalibrateSession from "./RunningAccountsProject/GasDetector/CalibrateSession";
import AllPlants from "./RunningAccountsProject/Plants/AllPlants";
import Addplants from "./RunningAccountsProject/Plants/Addplants";
import EditPlant from "./RunningAccountsProject/Plants/EditPlant";
import CalibrationGas from "./RunningAccountsProject/GasDetector/CalbrationGasMaster/CalibrationGas";
import AddCalibrationGas from "./RunningAccountsProject/GasDetector/CalbrationGasMaster/AddCalibrationGas";
import EditGasCalibration from "./RunningAccountsProject/GasDetector/CalbrationGasMaster/EditGasCalibration";
import CalibrationLogs from "./RunningAccountsProject/GasDetector/CalibrationLogs";
import AdminUser from "./tables/AdminUser";
import EditMonthlyInventoryReport from "./EditsForms/EditMonthlyInventoryReport";
import EditManualWorkPermit from "./EditsForms/EditManualWorkPermit";

import IqcmFormList from "./IQCM/IqcmFormList";
import AddIqcmForm from "./IQCM/AddIqcmForm";
import IqcmFormView from "./IQCM/IqcmFormView";
import IqcmReport from "./IQCM/IqcmReport";
import OMHeadViewDetails from "./ColdWorkPermit/OMHeadViewDetails.js";
import EditLocation from "./MiIndex/EditLocation.js";
import AddLocation from "./MiIndex/AddLocation.js";
import ViewLocation from "./MiIndex/ViewLocation.js";
import MIEvaluationList from "./MiIndex/MIEvaluationList.js";
import AddMIEvaluation from "./MiIndex/AddMIEvaluation.js";
import EditMIEvaluation from "./MiIndex/EditMIEvaluation.js";
import ViewMIEvaluation from "./MiIndex/ViewMIEvaluation.js";
import MIReports from "./MiIndex/MIReports.js";
import ExpenseForm from "./forms/ExpenseForm.js";
import AllExpenses from "./tables/AllExpenses.js";
import ExpenseView from "./Views/ExpenseView.js";
import ExpenseEdit from "./EditsForms/ExpenseEdit.js";
import ExpenseReports from "./Expense/ExpenseReports.js";
import ExpenseItems from "./Expense/ExpenseItems.js";
import Expense from "./Expense/Expense.js";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [backendErrorMessage, setBackendErrorMessage] = useState("");
  const [backendErrorOpen, setBackendErrorOpen] = useState(false);

  const token = localStorage.getItem("authKey");

  useEffect(() => {
    const authKey = localStorage.getItem("authKey");
    const name = localStorage.getItem("userName");

    if (authKey && name) {
      setLoggedIn(true);
      setUserName(name);
    } else {
      setLoggedIn(false);
      setUserName("");
    }

    // Simulate a delay to see the loader
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    const handleBackendError = (event) => {
      const message = event.detail?.message;

      if (message) {
        setBackendErrorMessage(message);
        setBackendErrorOpen(true);
      }
    };

    window.addEventListener("backend-error-snackbar", handleBackendError);

    return () => {
      window.removeEventListener("backend-error-snackbar", handleBackendError);
    };
  }, []);

  const handleLogin = async (
    authKey,
    name,
    email,
    company_id,
    user_role,
    project_type,
  ) => {
    // const handleLogin =  (authKey, name, email, company_id) => {
    if (authKey && name) {
      localStorage.setItem("authKey", authKey);
      localStorage.setItem("userName", name);
      localStorage.setItem("email", email);
      localStorage.setItem("company_id", company_id);
      localStorage.setItem("user_role", user_role);
      localStorage.setItem("project_type", project_type);
      setLoggedIn(true);
      setUserName(name);
    }
  };

  const handleSidebarToggle = (expanded) => {
    setIsSidebarExpanded(expanded);
  };

  return (
    <Router>
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <div>Loading...</div>
        </div>
      ) : (
        <Routes>
          {!loggedIn && <Route path="*" element={<Navigate to="/login" />} />}
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/" element={<Login onLogin={handleLogin} />} />
          <Route path="/signup" element={<SignUp />} />
          {loggedIn && (
            <>
              <Route
                path="/iqcm-form-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <IqcmFormList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/qc-reports"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <IqcmReport isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/add-new-iqcmForm"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddIqcmForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/iqcmForm-view/:formId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <IqcmFormView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/expenses"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AllExpenses isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/expense-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExpenseForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/expense-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExpenseView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/expense-edit/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExpenseEdit isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/add-hr-training-certificate"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="create"
                    />
                  </div>
                }
              />
              <Route
                path="/add-hr-training-session"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="create"
                    />
                  </div>
                }
              />
              <Route
                path="/edit-hr-training-certificate/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="edit"
                    />
                  </div>
                }
              />
              <Route
                path="/edit-hr-training-session/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="edit"
                    />
                  </div>
                }
              />
              {/* <Route
                path="/hr-training-certificate-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionsListPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              /> */}
              <Route
                path="/training/training-sessions"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionsListPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />

              <Route
                path="/add-hr-medical-report"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MedicalReportFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="create"
                    />
                  </div>
                }
              />
              <Route
                path="/edit-hr-medical-report/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MedicalReportFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="edit"
                    />
                  </div>
                }
              />
              <Route
                path="/hr-medical-report-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MedicalReportsListPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/hr-medical-report-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MedicalReportViewPage isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hr-training-certificate-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionViewPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/hr-training-session-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingSessionViewPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/training/catalouge"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingMastersListPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/training/standards"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingStandardsListPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/add-hr-training-standard"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingStandardFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="create"
                    />
                  </div>
                }
              />
              <Route
                path="/edit-hr-training-standard/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingStandardFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="edit"
                    />
                  </div>
                }
              />
              <Route
                path="/hr-training-standard-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingStandardViewPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/add-hr-training-master"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingMasterFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="create"
                    />
                  </div>
                }
              />
              <Route
                path="/edit-hr-training-master/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingMasterFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="edit"
                    />
                  </div>
                }
              />
              <Route
                path="/hr-training-participants"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingParticipantsListPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/add-hr-training-participant"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingParticipantFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="create"
                    />
                  </div>
                }
              />
              <Route
                path="/edit-hr-training-participant/:sessionId/:participantId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingParticipantFormPage
                      isSidebarExpanded={isSidebarExpanded}
                      mode="edit"
                    />
                  </div>
                }
              />
              <Route
                path="/hr-training-master-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingMasterViewPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              {/* <Route
                path="/hr-training-compliance"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingDashboardPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              /> */}
              <Route
                path="/training/dashboard"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingDashboardPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/training/due-overdue"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingDueOverduePage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/hr-training-employee-history/:employeeId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TrainingEmployeeHistoryPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/hr-medical-compliance"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MedicalCompliancePage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/medical/dashboard"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MedicalDashboardPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/medical/due-overdue"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MedicalDueOverduePage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/notification-config"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ReminderSettingsPage
                      isSidebarExpanded={isSidebarExpanded}
                      moduleType="all"
                    />
                  </div>
                }
              />
              <Route
                path="/email-logs"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EmailLogPage isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/pm-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PMListView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/breakdown-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Breakdownlistview isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Amclistview isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hrm-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Hrmlistview isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/statutory-approvals-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <StatutoryApprovalsListView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/pr-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PRListView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/po-list-stock-pr"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <POListView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/work-permit-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <WorkPermitListView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/audit-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AuditListView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-locations"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <LocationList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-add-location"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddLocation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-edit-location/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditLocation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-location-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ViewLocation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-evaluations"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MIEvaluationList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-add-evaluation"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddMIEvaluation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-edit-evaluation/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditMIEvaluation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/mi-evaluation-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ViewMIEvaluation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              {/* Reports Route */}
              <Route
                path="/mi-reports"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MIReports isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/add-new-permit-field"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddNewPermitField isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/TemplategetForm"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TemplategetForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/TemplateApiEndPoint"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TemplateApiEndPoint
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/admin-users"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AdminUser isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/admin-user-access-table/:ID"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AdminUserAccessTable
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/boq-add-details/:id/:billing_frequency"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BOQAddQtyDetails isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/boq-add-details-week/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BOQAddQtyForWeek isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/boq-add-details-month/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BOQAddQtyForMonths isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/boqs"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BOQTable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/boqs-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BOQForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/boqs-edit-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BOQEditForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-customers-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AMCCustomerForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/boq-reports/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BOQReports isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-customers"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AMCCustomerTable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-customers-edit-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AMCCustomerEditForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              {/* <Route
                path="/vendor-returnable"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Returnable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/amc-projects"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AMCProjectTable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-projects-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AMCProjectForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-projects-edit-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AMCProjectEditForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/general-report"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ReportPage isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/schedule_generator"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ScheduleGenerator isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/audit-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AuditForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/statutory-audits"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AuditTable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/audit-edit-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AuditEditForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/audit-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AuditView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/equipment-count-view/:frequency_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentCountView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              {/* // Route without date parameters (for 'all' filter and cases where dates don't exist) */}
              <Route
                path="/schedule-report-view/:department_id/:filter_option/:status"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PreventiveReportView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              {/* // Route with date parameters (for other filters with valid dates) */}
              <Route
                path="/schedule-report-view/:department_id/:filter_option/:status/:startDate/:endDate"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PreventiveReportView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/amc-report-view/:department_id/:filter_option/:status"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcReportView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/amc-report-view/:department_id/:filter_option/:status/:startDate/:endDate"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcReportView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/breakdown-report-view/:department_id/:filter_option/:status"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Breakdownreportview
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/procurement-report-view/:department_id/:filter_option/:pr_status"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ProcurementReportView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/procurement-report-view/:department_id/:filter_option/:pr_status/:startDate/:endDate"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ProcurementReportView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/user"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <User isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/expense/advance"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Expense isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/expense/items"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExpenseItems isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/expense/reports"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExpenseReports isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />

              <Route
                path="/user-acess-table/:ID"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UserAccessTable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                // path="/cold-work-permit"
                path="/permit-requests"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestForRequesterTab
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                // path="/form2"
                path="/checklistitems"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Form2 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/excavation-all-department-forms"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <IssuerAllDepartmentForms
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              {/* ColdWorkPermitDetail */}
              {/* ColdWorkPermitInspection */}
              <Route
                path="/work-permit-inspection"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestForSafetyTab
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/excavation-department-review"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestofExcavation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/excavation-department-approval-setup"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExcavationDepartmentApprovalSetup
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/add-excavation-department-approval-setup"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddExcavationDepartmentApprovalSetup
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-excavation-department-approval-setup/:permitTypeId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditExcavationDepartmentApprovalSetup
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/excavation-reviewer-configuration"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExcavationDepartmentReviewerConfiguration
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/add-excavation-reviewer-configuration"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddExcavationReviewerConfiguration
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-excavation-reviewer-configuration/:departmentId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditExcavationReviewerConfiguration
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/cold-work-permit-inspection-view/:work_permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ColdWorkPermitInspectionView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/issuer-view-details/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <IssuerViewDetails isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/view-pdf-formate/:permit_id/:work_permit_name/:wp_status"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitPdfFormate isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/cold-work-permit"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestForIssuerTab
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              {/* <Route
                path="/cold-work-permit-request-list/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ColdWorkPermitRequestList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              /> */}
              <Route
                path="/permit-view/:permit_id/:permit_type_id/:work_permit_name/:wp_status"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitViewPage isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/excavation-permit-view/:permit_id/:department_name"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExcavationPermitViewPage
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/excavation-view-inspection/:permit_id/:permit_type_id/:work_permit_name/:wp_status"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ExcavationViewInspection
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/cold-work-permit-form/:permit_id/:permit_type_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestEditTab
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/close-request-tab/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CloseRequestTabIssuer
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/close-request-tab-inspection/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CloseRequestTabInspection
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/close-request-tab-requester/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CloseRequestTabRequester
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/reject-req/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestRejectView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-email-template/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditEmailTemplate isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-daily-progress/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditDailyProgress isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/daily-progress-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <DailyProgressForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/email-configuration"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EmailConfig isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/email-config-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EmailConfigForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/cold-work-permit-config"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <WorkPermitConfig isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/daily-work-progress"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <DailyProgress isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              {/* <Route
                path="/Permit-request-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Form1 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/form1"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Form1 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/permit-request-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-permit-request-form/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestFormEdit
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/request-issue/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Form2 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/form3"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Form3 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/returnable-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ReturnableForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/returnable-items"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Returnable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-returnable/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditReturnable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-extension/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitExtensionRequestEdit
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-extension-reason/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditExtensionRequestReason
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/view-extension/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitExtensionRequestView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/view-extension-requester/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitExtensionRequestRequesterView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/oandm-view-details/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <OMHeadViewDetails isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/form4/:permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Form4 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/form5/:work_permit_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Form5 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/safety-induction"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyInduction isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-safety-induction"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedSafetyInduction
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/safety-induction-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyInductionForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-safety-induction/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditSafetyInduction
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/hse-policies"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HsePoliciesList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hse-policies-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HsePolicyForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-hse-policy/:policyId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditHsePolicy isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hse-policies-view/:policyId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HsePolicyView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/safety-observations"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyObservationList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/safety-observations-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyObservationForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-safety-observation/:observationId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditSafetyObservation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/safety-observations-view/:observationId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyObservationView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/safety-meetings"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyMeetingsList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/safety-meetings-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyMeetingForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-safety-meeting/:meetingId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditSafetyMeeting
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/safety-meetings-view/:meetingId"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SafetyMeetingsView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/cold-work-permit-template"
                element={
                  <div>
                    {/* <Sidebar onSidebarToggle={handleSidebarToggle} /> */}
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ColdWorkPermitTemplate
                    // isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/confined-space-template"
                element={
                  <div>
                    {/* <Sidebar onSidebarToggle={handleSidebarToggle} /> */}
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ConfinedSpaceTemplate
                    // isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/hot-work-permit-template"
                element={
                  <div>
                    {/* <Sidebar onSidebarToggle={handleSidebarToggle} /> */}
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HotWorkPermitTemplate
                    // isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/product-library-categories"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <DocumentCategory isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-product-library-categories"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedDocumentCategory
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/category-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <LibraryCategoryForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/email-history/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <DailyProgressEmailHistory
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-hr-modules/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditHRModules isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-category-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditLibraryCategory
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-email-config/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditEmailConfig isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-document-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditLibraryDocument
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/report-logs"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ReportLog isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hr-modules"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HrTable isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-hr-modules"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedhrList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hr-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HRForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/library-documents/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <DocumentLibrary isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/library-documents-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <LibraryDocumentsForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/all-schedules"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AllPreventiveSchedules
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/generate-po/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <GeneratePO isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-consumptions"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcConsumption isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-amc-consumptions"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedAmcConsumption
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/amc-consumptions-history/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcConsumptionHistory
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/product-inventory"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Inventory isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-inventory"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedInventory isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              {/* <Route
                path="/product-inventory-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <InventoryView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/product-inventory-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <InventoryHistory isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              {/* <Route
                path="/product-inventory-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <RejectedHistory isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/approved-technical-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ApprovedTechnicalView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/new-po"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <POConfigurationForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/po-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <POView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hr-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HRView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/po-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PoLisTtab isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/po-list-tab"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <POConfigurationlist
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/archived-po-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedPoList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/po-inbound-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <InwardForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/manual-work-permit-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ManualWorkPermitForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/manual-workpermit"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ManualWorkPermitList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/gas-detector-calibration-report"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CalibrationReports isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/calibration-report-view/:detector_id/:filter_option/:status/:startDate/:endDate"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CalibrationReportView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/po-inbound-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <InwardList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-po-inbound-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedInward isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/outward-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <OutwardList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-outward-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedOutwardlist
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/outward-Form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <OutwardForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-poconfiguration"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditPOConfiguration
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-outward"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditOutward isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-inward"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditInward isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              {/* <Route
                path="/schedules-reports"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PreventiveReports isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/mat-code"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MatCode isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-mat-code"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedMatcode isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              {/* <Route
                path="/archived-level3"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedLevel3 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/maintenance-history"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <History isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/inward-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <InwardView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/outward-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <OutwardView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-configuration"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcSchedules isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/pr-request"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PRRequest isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-pr-request"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedPrRequest isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/user-view/:userID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UserView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/amc-view/:amcID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/contractor-view"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ContractorView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/customer-view/:customerID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CustomerView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/frequency-view"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <FrequencyConfigView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/project-view/:projectID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ProjectView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/joining-history/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ManpowerHistory isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/statutory-view-view"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <StatutoryCompliancesView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/equipment-view"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              {/* <Route
                path="/dashboard"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Dashboard isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/dashboard"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <NewDashboard isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/new-dashboard-page"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <NewDashboardPage isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/pr-request-view/:pr_request_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PRRequestView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/pr-request-detail/:pr_request_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PRRequestDetail isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-mat-code-l1/:l1_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UpdateMatCodeLevel1
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/archived-level1-matcode"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedLevel1 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-mat-code-l2/:l2_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UpdateMatCodeLevel2
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              {/* <Route
                path="/archived-level-3"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedLevel3 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              /> */}
              <Route
                path="/archived-level2-matcode"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedLevel2 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-level3-matcode"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedLevel3 isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-mat-code-l3/:l3_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UpdateMatCodeLevel3
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/new-mat-code"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MatCodeConfigForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/matcode-levels"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <LevelConfig isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/level1-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Level1Form isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/level2-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Level2Form isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/level3-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Level3Form isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/pr-request-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PRRequestForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-pr-request-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditPRRequest isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-schedules"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AllAmcSchedules isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/rejected-po-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <RejectedStock isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-rejected-stock"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedRejectedStock
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/rejected-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <RejectedStockView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/pr-requests-list-tab"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PRRequestList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              PRRequestListTab
              <Route
                path="/pr-requests-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PRRequestListTab isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/approved-pr-requests"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ApprovedPRList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/voyages"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <VoyageList isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/monthly-inventory-report-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MonthlyInventoryReportList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/archived-approved-pr-requests"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedApprovedPR isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/amc-schedules-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcSchedulesForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/userform"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UserForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/voyageform"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <VoyageForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/monthly-inventory-report-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MonthlyInventoryReport
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-statutory-compliance/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditStatutoryCompliance
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/statutory-compliance-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <StatutoryComplianceForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/statutory-compliance"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <StatutoryCompliance
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/archived-statutory-compilance"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedStatutory isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/breakdown-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BreakDownForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/new-equipment"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <NewEquipment isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/vendor-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />

                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <VendorForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/HrCompilance-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />

                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HrCompilanceForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/all-notification"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />

                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AllNotification isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/vendors"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Vendor isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/hr-compliances"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <HrCompilances isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/Edit-hr-Compilance/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditHrCompilance isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-vendor"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedVendor isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/pr-vendor-details/:vendor_id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PrVendorDetails isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-vendor/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditVendor isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/contractor-Company"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ContractorCompany isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/equipment-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/inward-technical-inspection-list"
                //  path="/technical-pr-request-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TechnicalRequestList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/archived-inward-technical-inspection-list"
                //  path="/technical-pr-request-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedTechnicalList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/technical-pr-request-list-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <TechnicalRequestListView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/archived-pr-request-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedPrRequestList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/technical-pr-approved-list"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ApprovedTechnical isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/new-equipment-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <NewEquipmentForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/equipment-type"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentType isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/designations"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Designation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/archived-designations"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedDesignations
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/edit-designation/:ID"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditDesignation isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/designation-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <DesignationForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/side-petty-cash"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SidePettyCash isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/side-petty-cash-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SidePettyCashForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-side-petty-cash"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditSidePettyCash isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/equipment-type-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentTypeForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/contractor-company-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ContractorCompanyForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/equipment-sub-type"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentSubType isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/equipment-sub-type-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentSubTypeForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/oandm-head-inspection"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PermitRequestForOMHeadTab
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/equipment-sub-type-variant"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentTypevariant
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/equipment-sub-type-variant-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EquipmentTypevariantForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                path="/user-type"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UserType isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/email-template-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EmailTemplateForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/email-templates"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EmailTemplate isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/manpowerrequirment-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ManpowerRequirmentForm
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </div>
                }
              />
              <Route
                // path="/manpower-requirements/:id"
                path="/manpower-requirements"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ManpowerRequirment isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                // path="/actualmanpower/:id"
                path="/actual-manpowers"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ActualManpower isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/actualmanpower-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ActualManpowerForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-man-powers-form/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditManpower isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-actual-man-powers/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditActualManpower isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                // path="/report-manpower/:id"
                path="/manpower-report"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ReportManpower isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-contractor/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditContractor isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-amc/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditAmcForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-mat-code"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditMatCode isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/vendor-view/:id"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <VendorView isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/department"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Department isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/sub-department"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SubDepartment isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/department-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <DepartmentForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/sub-department-form"
                element={
                  <div>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <SubDepartmentForm isSidebarExpanded={isSidebarExpanded} />
                  </div>
                }
              />
              <Route
                path="/edit-user/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditUserForm isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-equipment-type/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditEquipmentType isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-frequency/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditFrequency isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-breakdown/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditBreakdown isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-new-equipment/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditNewEquipment isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/reminders/:department_id/:due_type"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ReminderDetails isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/:department_name/:department_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ElectricalDepartment
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/frequency"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Frequency isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archived-frequency"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedFrequency isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/project-form"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ProjectForm isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/customer-form"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CustomerForm isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-customer/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditCustomer isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-project/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditProject isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/project"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Project isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/breakdown-schedules"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BreakDownSchedules isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archived-breakdown"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedBreakdown isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/customer"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Customer isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/barrel-customers"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CustomerList isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/barrel-view-customer/:customer_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ViewCustomer isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/barrel-purchase-indents"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PurchaseIndentsList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/barrel-products"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ProductList isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/barrel-inward"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BarrelInwardList isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/barrel-ledger"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <StockLedgerList isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/frequency-config"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <FrequencyConfig isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-equipment-sub-Type/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditEquipmentSubType
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/edit-equipment-sub-type-variant/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditEquipmentSubTypeVariant
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/edit-department/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditDepartment isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-voyage/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditVoyage isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-monthly-inventory-report/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditMonthlyInventoryReport
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/edit-manual-work-permit/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditManualWorkPermit
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/edit-sub-department/:ID"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditSubDepartment isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archive-user"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedUser isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archive-All-AMC-Schedules"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedAllAmcSchedules
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/archive-All-AMCs"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedAllAmcs isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archive-department"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedDepartment isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/scheduler-view/:scheduler_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PreventiveSchedulesView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/breakdown-scheduler-view/:breakdown_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <BreakdownView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/amc-scheduler-view/:schedule_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AmcSchedulesView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/approved-pr-view/:pr_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ApprovedPrView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/monthly-inventory-view/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <MonthlyInventoryView
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/voyage-view/:voyage_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <VoyageView isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/update-mat-code/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <UpdateMatCode isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archive-sub-department"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedSubDepartment
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              ArchivedContractorCompany
              <Route
                path="/archive-contractor-company"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedContractorCompany
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/archive-equipment"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedEquipment isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archive-All-Schedule"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedAllSchedules
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/archive-customer"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedCustomer isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archive-Actual-man-Power"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedActualmanPower
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/archive-man-required/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedManPowerRequire
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/archive-project"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedProject isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/archive-equipment-type"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedEquipmentType
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/archive-equipment-sub-type"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedEquipmentSubType
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/archive-equipment-sub-type-variant"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <ArchivedEquipmentSubTypevariant
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/isolation-permits"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <IsolationPermitList
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/isolation-template"
                element={
                  <>
                    <IsolationTemplate isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/isolation-template/:permitId"
                element={
                  <>
                    <IsolationTemplate isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/request-isolation"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <RequestIsolation isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/request-isolation/:permitId"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <RequestIsolation isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/request-energisation"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <RequestEnergisation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/request-energisation/:permitId"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <RequestEnergisation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/isolation-certificate"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CetificateIsolation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/isolation-certificate/:permitId"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CetificateIsolation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/energisation-certificate"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CetificateEnergisation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/energisation-certificate/:permitId"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CetificateEnergisation
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/gas-detector-form"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <GasDetectorForm isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/gas-detectors-types"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <GasDetectorTypes isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/add-gas-detector-type"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddGasDetectorType isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-gas-detector-type/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditDetectorType isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/gas-detectors"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AllGasDetector isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-gas-detector/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditGasDetector isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/gas-detectors-calibration"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <GasDetectorCallibaration
                      isSidebarExpanded={isSidebarExpanded}
                    />
                  </>
                }
              />
              <Route
                path="/cylinder-inventory"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AllGasCylinders isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/cylinder-inventory-form"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddCylinder isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-cylinder-inventory-from/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditGasCylinder isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/inventory-logs/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CylinderLogs isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/callibrate-sessions/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CalibrateSession isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/Plants"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AllPlants isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/Addplants"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <Addplants isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/EditPlant/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditPlant isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/calibration-gas-types"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CalibrationGas isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/add-calibration-form"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <AddCalibrationGas isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/edit-gas-Calibration/:id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <EditGasCalibration isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="/calibration-logs/:detector_id"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <CalibrationLogs isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
              <Route
                path="*"
                element={
                  <>
                    <Sidebar onSidebarToggle={handleSidebarToggle} />
                    <Header isSidebarExpanded={isSidebarExpanded} />
                    <PageNotFound isSidebarExpanded={isSidebarExpanded} />
                  </>
                }
              />
            </>
          )}
        </Routes>
      )}
      <Snackbar
        open={backendErrorOpen}
        autoHideDuration={6000}
        onClose={() => setBackendErrorOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert
          onClose={() => setBackendErrorOpen(false)}
          severity="error"
        >
          {backendErrorMessage}
        </MuiAlert>
      </Snackbar>
    </Router>
  );
};

export default App;
